import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "./package.css";

const Package = () => {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [cat, setCat] = useState('');
  const [com, setCom] = useState('');
  const [image, setImage] = useState('');
  const [link, setLink] = useState('');
  const [id, setId] = useState("");
  const [temp, setTemp] = useState("");
  const [catList, setCatList] = useState([]);

  const name = localStorage.getItem("@^&*$£%$!##%admin@^&*$£%$!##%");
  const db = firebase.firestore();
  const itemsRef = db.collection("products");

  useEffect(() => {
    const dataArray = [];
    const db = firebase.firestore();
    db.collection("catagories").get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          dataArray.push({ id: doc.id, ...doc.data() });
        });
        setCatList(dataArray);
      });
  },[])

  const create = async (e) => {
    try {
      if (!title) {
        return toast.error("Title is Required");
      }
      if (!cat) {
        return toast.error("Catagory is Required");
      }
      if (!price) {
        return toast.error("Price is Required");
      }
      if (!com) {
        return toast.error("Comment is Required");
      }
      if (!image) {
        return toast.error("Image link is Required");
      }
      if(!link){
        return toast.error('Link is required');
      }
      /**  */
      const query = itemsRef.where("title", "==", title);
      query.get().then((querySnapshot) => {
        if (querySnapshot.size > 0) {
          // eslint-disable-next-line
          const doc = querySnapshot.docs[0];
          toast.error("Title Already in Use");
          return;
        } else {
          itemsRef
            .add({
              title,
              cat,
              image,
              price,
              com,
              link,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then((docRef) => {
              toast.success("Product Added");
              setTitle("");
              setCat("");
              setImage('');
              setPrice("");
              setCom("");
              setLink("");
            })
            .catch((error) => {
              toast.error("Error in Adding New Product");
            });
        }
      });
    } catch (error) {
      console.log(error);
      toast.error("Something went Wrong");
    }
  };

  const read = async (e) => {
    e.preventDefault();
    if (!title) {
      return toast.error("Title is Required");
    }
    const query = itemsRef.where("title", "==", title);
    query
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.size > 0) {
          querySnapshot.forEach((doc) => {
            setTitle(title);
            setTemp(title);
            setId(doc.id);
            setCat(doc.data().cat);
            setImage(doc.data().image);
            setCom(doc.data().com);
            setPrice(doc.data().price);
            setLink(doc.data().link);
            toast.success("Product Details Loaded");
          });
        } else {
          toast.error("Product Not Foound");
        }
      })
      .catch((error) => {
        toast.error("Error Getting Product ");
      });
  };

  const update = async (e) => {
    e.preventDefault();
    if (!title) {
      return toast.error("Please Enter Title and Click on Get Product");
    }
    if (id === "") {
      return toast.error("Click on Get Product");
    }

    try {
      if (!cat) {
        return toast.error("Catagory is Required");
      }
      if (!price) {
        return toast.error("Price is Required");
      }
      if(!com){
        return toast.error('Comment is required');
      }
      if (!image) {
        return toast.error("Image Link is Required");
      }
      if(!link){
        return toast.error('Link is required');
      }
      if (temp === title) {
        const docRef = itemsRef.doc(id);
        docRef
          .update({
            title,
            cat,
            image,
            price,
            com,
            link,
          })
          .then((data) => {
            toast.success("Product Updated Successfully");
            setTitle("");
            setCat("");
            setImage('');
            setPrice("");
            setId("");
            setCom("");
            setLink("");
          })
          .catch((error) => {
            toast.error("Error in Updating Product");
          });
      } else {
        const query = itemsRef.where("title", "==", title);
        query.get().then((querySnapshot) => {
          if (querySnapshot.size > 0) {
            // eslint-disable-next-line
            const doc = querySnapshot.docs[0];
            toast.error("Title Already in Use");
            return;
          } else {
            const docRef = itemsRef.doc(id);
            docRef
              .update({
                title,
                cat,
                image,
                price,
                com,
                link,
              })
              .then((data) => {
                toast.success("Product Updated Successfully");
                setTitle("");
                setCat("");
                setImage("");
                setPrice("");
                setId("");
                setCom("");
                setLink("");
              })
              .catch((error) => {
                toast.error("Error in Updating Product");
              });
          }
        });
      }
    } catch (error) {
      toast.error("Something went Wrong");
    }
  };
  const deletee = async (e) => {
    e.preventDefault();
    if (!title) {
      return toast.error("Please Enter Title and Click on Get Product");
    }
    if (id === "") {
      return toast.error("Click on Get Product");
    }
    try {
      const docRef = itemsRef.doc(id);
      docRef
        .delete()
        .then((data) => {
          toast.success("Product Deleted Successfully");
          setTitle("");
          setCat("");
          setImage("");
          setPrice("");
          setId("");
          setCom("");
          setLink("");
        })
        .catch((error) => {
          toast.error("Product not Deleted");
        });
    } catch (error) {
      toast.error("Something went Wrong");
    }
  };

  return (
    <div className="p-main">
      <h2>Admin {name}</h2>
      <div className="a-main mt-2">
          <div className="p-main">
            <h4 className="mt-3">Products</h4>

            <input
              type="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="form-control"
              placeholder="Title "
              required
              autoFocus
            />

            <select value={cat} onChange={(e) => setCat(e.target.value)}>
              <option value=''>Select Catagory</option>
              {catList.map((c,i) => {
                return <option value={c.title} key={i}>{c.title}</option>
              })}
              
            </select>

            <input
              type="text"
              value={image}
              onChange={(e) => setImage(e.target.value)}
              className="form-control"
              placeholder="Image Link"
              required
            />

            <input
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="form-control"
              placeholder="Price"
              required
            />

            <input
              type="text"
              value={com}
              onChange={(e) => setCom(e.target.value)}
              className="form-control"
              placeholder="Comment"
              required
            />

              <input
              type="text"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              className="form-control"
              placeholder="Link"
              required
            />

            <div className="mb-3 bbtn">
              <button onClick={create}>Add Product</button>
              <button onClick={read}>Get Product</button>
              <button onClick={update}>Update Product</button>
              <button onClick={deletee} className=" mt-2">
                Delete Product
              </button>
            </div>
          </div>
      </div>
    </div>
  );
};

export default Package;